import React from 'react'
import DataTable from './DataTable';
import SectionCard from './SectionCard';

const operatingcostsdata = [
    {
        id: 1,
        sr: 1,
        product: "-",
        project: "-",
        period: "one monthly table",
        openType: "Property Tax",
        budget: "-",
        actual: "-",
        difference: "-",
    },
    {
        id: 2,
        sr: 2,
        product: "-",
        project: "-",
        period: "one annual table",
        openType: "Insurance",
        budget: "-",
        actual: "-",
        difference: "-",
    },
    {
        id: 3,
        sr: 3,
        product: "-",
        project: "-",
        period: "-",
        openType: "G&A",
        budget: "-",
        actual: "-",
        difference: "-",
    },
];

const OperatingCostsNew = () => {
    const columns = [
        { field: "sr", headerName: "#" },
        { field: "product", headerName: "Product" },
        { field: "project", headerName: "Project" },
        { field: "period", headerName: "Period" },
        { field: "openType", headerName: "Open Type" },
        { field: "budget", headerName: "Budget" },
        { field: "actual", headerName: "Actual" },
        { field: "difference", headerName: "Difference" },
    ];

    return (
        <>
            <SectionCard title="Operating costs" description="Tracking ongoing expenses against budgets for better cost management" />
            <DataTable columns={columns} data={operatingcostsdata} />
        </>
    );
}

export default OperatingCostsNew
